import { z } from 'zod'

export const PaginatedResponseSchema = <T extends z.ZodType>(itemSchema: T) =>
  z.object({
    data: z.array(itemSchema),
    total: z.number().int(),
    limit: z.number().int(),
    offset: z.number().int()
  })

export type PaginatedResponse<T> = {
  data: T[]
  total: number
  limit: number
  offset: number
}
